import { ViewPaymentDetailsCarousel } from "./AvailableCarouselBlocks/ViewPaymentDetails";
import { AskNowCarousel } from "./AvailableCarouselBlocks/AskNow";
import { NotFoundBannerCarousel } from "./AvailableCarouselBlocks/BannerNotFound";
import { HXConnectCarousel } from "./AvailableCarouselBlocks/HXConnect";
import { MyLouieTasksCarousel } from "./AvailableCarouselBlocks/MyLouieTasks";
import { WelcomeBannerCarousel } from "./AvailableCarouselBlocks/WelcomeBanner";
import { EmployeeReferralProgramCarousel } from "./AvailableCarouselBlocks/EmployeeReferralProgram";
import { EmployeeResourceGroupCarousel } from "./AvailableCarouselBlocks/EmployeeResourceGroup";
import { MentalHealthCarousel } from "./AvailableCarouselBlocks/MentalHealth";
import { HappyBirthdayCarousel } from "./AvailableCarouselBlocks/HappyBirthday";
import { HappyAnniversaryCarousel } from "./AvailableCarouselBlocks/HappyAnniversary";
import { MyScheduleCarousel } from "./AvailableCarouselBlocks/MySchedule";
import { ShoutOutBannerCarousel } from "./AvailableCarouselBlocks/ShoutOutBanner";
import {NaviBannerCarousel} from "./AvailableCarouselBlocks/NaviBanner";

const CarouselIndex = [
  {
    BannerName: "Welcome to TTEC",
    Component: WelcomeBannerCarousel,
  },
  {
    BannerName: "Recognize a Colleague Today",
    Component: ShoutOutBannerCarousel,
  },
  {
    BannerName: "My Louie Tasks",
    Component: MyLouieTasksCarousel,
  },
  {
    BannerName: "HXconnect",
    Component: HXConnectCarousel,
  },
  {
    BannerName: "ASKNow",
    Component: AskNowCarousel,
  },
  {
    BannerName: "View Payment Details",
    Component: ViewPaymentDetailsCarousel,
  },
  {
    BannerName: "Employee Referral Program",
    Component: EmployeeReferralProgramCarousel,
  },
  {
    BannerName: "Employee Resource Groups (ERGs)",
    Component: EmployeeResourceGroupCarousel,
  },
  {
    BannerName: "Mental Health",
    Component: MentalHealthCarousel,
  },
  {
    BannerName: "Birthday Wishes",
    Component: HappyBirthdayCarousel,
  },
  {
    BannerName: "Happy Anniversary",
    Component: HappyAnniversaryCarousel,
  },
  {
    BannerName: "My Schedule",
    Component: MyScheduleCarousel,
  },
  {
    BannerName: "TTEC Intranet - Navi",
    Component: NaviBannerCarousel,
  },
];

export const GetBanner = (
  index: string,
  props: any,
  key: number,
  countryName: string,
  web_url: string,
  mobile_url: string,
  is_sso: string,
  display_text: string,
  is_url: string,
  url: string
) => {
  const banner = CarouselIndex.find((b) => b.BannerName === index);

  //console.log("GetBanner Props:", props);

  // Extra props for Birthday and Anniversary banners
  if (banner) {
    if (index === "Birthday Wishes") {
      if (!props?.isBirthDay) return null;
      return (
        <banner.Component
          {...props}
          key={key}
          countryName={countryName}
          web_url={web_url}
          mobile_url={mobile_url}
          display_text={display_text}
          is_sso={is_sso}
          isBirthDay={props?.isBirthDay}
          isAnniDay={props?.isAnniDay}
          displayName={props?.displayName}
          url={url}
          is_url={is_url}
        />
      );
    }

    if (index === "Happy Anniversary") {
      if (!props?.isAnniDay) return null;
      return (
        <banner.Component
          {...props}
          key={key}
          countryName={countryName}
          web_url={web_url}
          mobile_url={mobile_url}
          is_sso={is_sso}
          display_text={display_text}
          isAnniDay={props?.isAnniDay}
          expYears={props?.expYears}
          displayName={props?.displayName}
          url={url}
          is_url={is_url}
        />
      );
    }
    if (index === "My Schedule") {
      if (!(props?.classRosterAndRequestId?.ClassRosterId === "14685" || props?.classRosterAndRequestId?.ClassRosterId === "145"  || props?.classRosterAndRequestId?.ClassRosterId === "20132"  || props?.classRosterAndRequestId?.ClassRosterId === "20161"  || props?.classRosterAndRequestId?.ClassRosterId === "20217"  || props?.classRosterAndRequestId?.ClassRosterId === "20218" || props?.classRosterAndRequestId?.ClassRosterId === "20851" || props?.classRosterAndRequestId?.ClassRosterId === "20850"  || props?.classRosterAndRequestId?.ClassRosterId === "20852"  || props?.classRosterAndRequestId?.ClassRosterId === "14686" || props?.classRosterAndRequestId?.ClassRosterId === "15555" || props?.classRosterAndRequestId?.ClassRosterId === "15556"  || props?.classRosterAndRequestId?.ClassRosterId === "15940" || props?.classRosterAndRequestId?.ClassRosterId === "15557" || props?.classRosterAndRequestId?.ClassRosterId === "18700" || props?.classRosterAndRequestId?.ClassRosterId === "18822" || props?.classRosterAndRequestId?.ClassRosterId === "17104" || props?.classRosterAndRequestId?.ClassRosterId === "20126")) return null;
      return (
        <banner.Component
          {...props}
          key={key}
          countryName={countryName}
          web_url={web_url}
          mobile_url={mobile_url}
          is_sso={is_sso}
          display_text={display_text}
          classRosterId={props?.classRosterAndRequestId?.ClassRosterId}
          displayName={props?.displayName}
          url={url}
          is_url={is_url}
        />
      );
    }

    // Default case for other banners
    return (
      <banner.Component
        {...props}
        key={key}
        countryName={countryName}
        web_url={web_url}
        mobile_url={mobile_url}
        display_text={display_text}
        is_sso={is_sso}
        is_url={is_url}
        url={url}
      />
    );
  }

  // Return a NotFoundBannerCarousel if the banner isn't found
  return <NotFoundBannerCarousel {...props} key={key} />;
};
